import { GetCurrencySymbol } from '../../../../../utils/Currency';
import { GetFloatNumber } from '../../../../../utils/NumberFormatter';
import { TextCapitalize } from '../../../../../utils/TextFormatter';

function Info({ title, value }) {
    return (
        <div className="flex items-center gap-x-4">
            <div className="w-[100px]">
                <p className="text-primary-700">{title}</p>
            </div>
            :
            <div className="w-[calc(100%_-_140px)]">
                <p className="text-primary">
                    <span> {value}</span>
                </p>
            </div>
        </div>
    );
}

// eslint-disable-next-line no-unused-vars
function InvoiceInfoRow({ invoiceData, billingAddress }) {
    const {
        customInvoiceNo,
        amountBilled,
        amountPaid,
        amountDue,
        currency,
        demo,
        isQuotation,
        quotationNo,
        status
    } = invoiceData || {};
    // const { address, city, country } = billingAddress || {};

    return (
        // <div className={`min-h-72 ${demo ? 'placeholder-mode' : ''}`}>
        <div className={`min-h-max ${demo ? 'placeholder-mode' : ''}`}>
            <div className="mb-4 flex items-center justify-between">
                <h2 className="text-primary text-xl font-normal">
                    {isQuotation ? 'Quotation Info' : 'Invoice Info'}
                </h2>
            </div>
            <div className="flex flex-col gap-y-2 pb-2 mb-2">
                {/* <Info title="Invoice Id" value={id} /> */}
                {/* <Info title="Currency" value={currency || 'USD'} /> */}
                {isQuotation ? (
                    <Info title="Quotation No." value={quotationNo || 'N/A'} />
                ) : (
                    <Info title="Invoice No." value={customInvoiceNo} />
                )}
                <Info
                    title="Billed Amount"
                    value={`${GetCurrencySymbol(currency)}${GetFloatNumber(amountBilled)}`}
                />
                {isQuotation ? null : (
                    <>
                        <Info
                            title="Paid Amount"
                            value={`${GetCurrencySymbol(currency)}${GetFloatNumber(amountPaid)}`}
                        />
                        <Info
                            title="Current Due"
                            value={`${GetCurrencySymbol(currency)}${GetFloatNumber(amountDue)}`}
                        />
                    </>
                )}
                {/* Show payment status */}
                {isQuotation ? null : (
                    <Info
                        title="Payment Status"
                        value={TextCapitalize(status.split('_').join(' '))}
                    />
                )}
            </div>

            {/* <div className="flex flex-col gap-y-2">
                <div className="flex items-start gap-x-4">
                    <div className="w-[100px]">
                        <p className="text-primary-700">Address</p>
                    </div>
                    :
                    <div className="w-[calc(100%_-_140px)]">
                        <p className="text-primary">
                            <span>
                                {[address, city, country].filter((d) => !!d).join(', ') ||
                                    '----------------------'}
                            </span>
                        </p>
                    </div>
                </div>
            </div> */}
        </div>
    );
}

export default InvoiceInfoRow;
